import React, { useRef } from 'react';

interface AccordionItemProps {
	title: string;
	value: string;
	isOpen: boolean;
	onClick: () => any;
}

const AccordionItem = (props: AccordionItemProps) => {
	const contentHeight = useRef<HTMLDivElement | null>(null)
	
	return (
		<div className="accordionItem">
			<button className={`accordionItem__title ${props.isOpen ? 'active' : ''}`} onClick={props.onClick}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="36"
					height="37"
					viewBox="0 0 36 37"
					fill="none"
				>
					<path d="M18 6.27734C18.8284 6.27734 19.5 6.94892 19.5 7.77734V28.7773C19.5 29.6058 18.8284 30.2773 18 30.2773C17.1716 30.2773 16.5 29.6058 16.5 28.7773V7.77734C16.5 6.94892 17.1716 6.27734 18 6.27734ZM25.5 12.2773C26.3284 12.2773 27 12.9489 27 13.7773V28.7773C27 29.6058 26.3284 30.2773 25.5 30.2773C24.6716 30.2773 24 29.6058 24 28.7773V13.7773C24 12.9489 24.6716 12.2773 25.5 12.2773ZM10.5 18.2773C11.3284 18.2773 12 18.9489 12 19.7773V28.7773C12 29.6058 11.3284 30.2773 10.5 30.2773C9.67157 30.2773 9 29.6058 9 28.7773V19.7773C9 18.9489 9.67157 18.2773 10.5 18.2773Z" fill="#7551FF"/>
				</svg>
				<div className="accordionItem__title_text">
					<h4>{props.title}</h4>
					<svg
						className={`accordionItem__title_text_arrow ${props.isOpen ? 'active' : ''}`}
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="25"
						viewBox="0 0 24 25"
						fill="none"
					>
						<path d="M5.29289 9.57024C5.68342 9.17971 6.31658 9.17971 6.70711 9.57024L12 14.8631L17.2929 9.57024C17.6834 9.17971 18.3166 9.17971 18.7071 9.57024C19.0976 9.96076 19.0976 10.5939 18.7071 10.9845L12.7071 16.9845C12.3166 17.375 11.6834 17.375 11.2929 16.9845L5.29289 10.9845C4.90237 10.5939 4.90237 9.96076 5.29289 9.57024Z" fill="white"/>
					</svg>
				</div>
			</button>
			
			<div
				ref={contentHeight}
				className={`accordionItem__value ${props.isOpen && 'opened'}`}
				style={
				props.isOpen && contentHeight && contentHeight.current && contentHeight.current.scrollHeight
					? { height: contentHeight.current.scrollHeight + 24 }
					: { height: "0px" }
				}
				onClick={props.onClick}
			>
				<p>{props.value}</p>
			</div>
		</div>
	);
};

export default AccordionItem;